var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"hamburger",class:{'is-active':_vm.isActive},on:{"click":_vm.toggleClick}},[_c('svg-icon',{attrs:{"icon-class":"menu-outline","class-name":"menu-icon"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }